$(document).ready(function () {

    $('.input_plan').on('change',function(){
        $(this).parent().addClass('active').siblings().removeClass('active');
       var id = $(this).val();
       var subs = $('.select-delivery-time option:selected').val();
       var price = $("#final_price").data('price');
       var discount = $("#final_price").data('discount');
       var compare = $("#final_price").data('compare');
        
       if(id == 1) {
          $('.discount-wrap').show();
          $('#selling_plan').val(subs);
          $(".reg_cost").text($('.subs_price').text());
          if(price > discount) {
            $('.product-discount-price').show();
          }else{
            $('.product-discount-price').hide();
          }
          $('.subscribe-text').addClass('show').removeClass('hide');
          $('.onetime-text').removeClass('show').addClass('hide');
        }else{
          $('.discount-wrap').hide();
          $('#selling_plan').val('');
          if(compare > price) {
            $('.product-discount-price').show();
          }else{
            $('.product-discount-price').hide();
          }
          $(".reg_cost").text($('.onetime_price').text());
          $('.subscribe-text').addClass('hide').removeClass('show');
          $('.onetime-text').removeClass('hide').addClass('show');
        }

    })

    $('.plan_input').on('change',function(){
      $(this).parent().addClass('active').siblings().removeClass('active');
     var id = $(this).val();
     var subs = $('.select-delivery-time option:selected').val();
     var price = $(".variant_selector option:selected").data('price');
     var compare = $(".variant_selector option:selected").data('compare');
     var bottle = $(".variant_selector option:selected").data('id');
     var rate = $(this).data('rate');
     var template = $('.template-name').val();

     option_change(id, subs, price, compare, rate, bottle, template);
  })

    $('.select-delivery-time').on('change',function(){
       var subs = $(this).val();
        $('#selling_plan').val(subs)
    })

    $('.variant_selector').on('change',function(){
        var id = $('.:checked').val(); 
        var subs = $('.select-delivery-time option:selected').val();
        var price = $("option:selected", this).data('price');
        var compare = $("option:selected", this).data('compare');
        var rate = $('.plan_input:checked').data('rate');
        var bottle = $("option:selected", this).data('id');
        var template = $('.template-name').val();
       
        option_change(id, subs, price, compare, rate, bottle, template);
      
    })

    // default selected discount 
    var price_select = $(".variant_selector option:selected").data('price');
    var compare_select = $(".variant_selector option:selected").data('compare');
    var rate_select = $('.plan_input:checked').data('rate');

    if(compare_select > price_select ) {
        price_select = price_select * 0.01;
        compare_select = compare_select * 0.01;
        var save = Math.floor(compare_select - (price_select * rate_select));
        $('.fixed-discount').text('Save ' + currency + save)
    }else{
        price_select = price_select * 0.01;
        var save = Math.floor(price_select - (price_select * rate_select));
        $('.fixed-discount').text('Save ' + currency + save)
    }

    // when enable quanity bundle 
    let price = $('.quanity_input:checked').data('price');
    let compare = $('.quanity_input:checked').data('compare');
    let rate = $('.quanity_input:checked').data('rate');

    if(compare > price ) {
      price = price * 0.01;
        compare = compare * 0.01;
        var save = (compare - (price * rate)).toFixed();
        $('.qty_discount').text('Save ' + currency + save)
    }else{
        price = price * 0.01;
        var save = (price - (price * rate)).toFixed();
        $('.qty_discount').text('Save ' + currency + save)
    }
});



function option_change(id, subs, price, compare, rate, bottle, template) {
   
    price = (price * 0.01).toFixed(2);
    compare = (compare * 0.01).toFixed(2);

    if(bottle == 1){
        $('.gift-item').hide();
    }else if (bottle == 2){
        $('#gift-item').show();
        $('#gift-card').hide();
    }else if (bottle == 3){
        $('#gift-item').hide();
        $('#gift-card').show();
    }

    if(id == 1) {
        $('#selling_plan').val(subs);
        $('.purchase-price-save').show();
        
        var discount_meal_1 = $('#price_1').data('discount')
        var discount_meal_2 = $('#price_2').data('discount')
        var discount_meal_3 = $('#price_3').data('discount')
      
        $('#price_1 span').text(currency + discount_meal_1);
        $('#price_2 span').text(currency + discount_meal_2);
        $('#price_3 span').text(currency + discount_meal_3);
              
        var save = 0;
        if(compare > price) { 
            $('.discount-price').text(currency + compare);
            save = Math.floor(compare - (price * rate));
            $('.fixed-discount').text('Save ' + currency + save);

        }else{
            $('.discount-price').text(currency + price);
            save = Math.floor(price - (price * rate));
            $('.fixed-discount').text('Save ' + currency + save)
        }

        var saving_1 = $('.save_price_1').data('subsprice');
        var saving_2 = $('.save_price_2').data('subsprice');
        var saving_3 = $('.save_price_3').data('subsprice');

        if (saving_1 > 0 || saving_2 > 0 || saving_3 > 0) {
            $('.purchase-price-save').show();
            if(saving_1 > 0) {
              $('#save_1').parent().show();
              $('#save_1').text(saving_1);
            } else {
              $('#save_1').parent().hide();
            }
            if(saving_2 > 0) {
              $('#save_2').parent().show();
              $('#save_2').text(saving_2);
            }else{
              $('#save_2').parent().hide();
            }
            if(saving_3 > 0) {
              $('#save_3').parent().show();
              $('#save_3').text(saving_3);
            }else{
              $('#save_3').parent().hide();
            }
        }else{
          $('.purchase-price-save').hide();
        }

        $('.reg-price').text(currency + (price * rate).toFixed(2));
        $('.total-value').show();
        $('.onetime_price').text(currency + price);
        $('.subs_price').text(currency + (price * rate).toFixed(2));


   }else{

    $('#selling_plan').val('');
    if (template == 'superfoodshake') {
        $('.purchase-price-save').show();
    } else if(template == 'burner'){
        $('.purchase-price-save').hide();
    } 


    var discount_meal_1 = $('#price_1').data('price')
    var discount_meal_2 = $('#price_2').data('price')
    var discount_meal_3 = $('#price_3').data('price')
  
    $('#price_1 span').text(currency + discount_meal_1);
    $('#price_2 span').text(currency + discount_meal_2);
    $('#price_3 span').text(currency + discount_meal_3);
      
    $('.reg-price').text(currency + price);

    var saving_1 = $('.save_price_1').data('price');
    var saving_2 = $('.save_price_2').data('price');
    var saving_3 = $('.save_price_3').data('price');
    

      if (saving_1 > 0 || saving_2 > 0 || saving_3 > 0 ) {
        $('.purchase-price-save').show();
        if(saving_1 > 0) {
          $('#save_1').parent().show();
          $('#save_1').text(saving_1);
        } else {
          $('#save_1').parent().hide();
        }
        if(saving_2 > 0) {
          $('#save_2').parent().show();
          $('#save_2').text(saving_2);
        }else{
          $('#save_2').parent().hide();
        }
        if(saving_3 > 0) {
          $('#save_3').parent().show();
          $('#save_3').text(saving_3);
        }else{
          $('#save_3').parent().hide();
        }
      }else{
        $('.purchase-price-save').hide();
      }
    var save = 0;
    if(compare > price) {
            $('.total-value').show();
            $('.discount-price').text(currency + compare);
            $('.onetime_price').text(currency + price);
            $('.subs_price').text(currency + price);
            save = Math.floor(compare - (price * rate));
            $('.fixed-discount').text('Save ' + currency + save);
    }else{
        $('.discount-price').text('');
        $('.total-value').hide();
        $('.onetime_price').text(currency + price );
        $('.subs_price').text(currency  + (price * rate).toFixed(2));
        save = Math.floor(price - (price * rate));
        $('.fixed-discount').text('Save ' + currency + save);
    }
   }
}